export const roundAccurately = (number: number, decimalPlaces: number) =>
// @ts-ignore
  Number(Math.round(number + "e" + decimalPlaces) + "e-" + decimalPlaces);
